import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class RoomAssignments extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'date',
    'rooms_info'
)(RoomAssignments);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/daily-activity/room-assignments.model.js